import { AscBadgeColor } from '../skill/badge-color';

export enum TransactionType {
  ALL = 'all',
  PURCHASED = 'purchased',
  EARNED = 'earned',
}

export enum FAQType {
  NEW_ACCOUNT = 'new_account',
  ACCOUNT_SETTINGS = 'profile',
  PAYMENTS = 'payments',
  LESSONS_POLICY = 'lessons',
}

export enum FAQTypeAdmin {
  NEW_ACCOUNT = 'NEW_ACCOUNT',
  ACCOUNT_SETTINGS = 'ACCOUNT_SETTINGS',
  PAYMENTS = 'PAYMENTS',
  LESSONS_POLICY = 'LESSONS_POLICY',
}

export interface ITransaction {
  id: string;
  createdAt: string;
  updatedAt: string;
  studentId: string;
  coins: number;
  description: string;
  type: TransactionType;
}

export interface ITransactionStatistics {
  earnedCoins: number;
  spentCoins: number;
  availableCoins: number;
}

export interface IFaq {
  id: string;
  createdAt: string;
  updatedAt: string;
  title: string;
  description: string;
  type: FAQType;
}

export interface IStatsPercategory {
  categoryId: string;
  name: string;
  badgeColor: AscBadgeColor;
  overallChallenges: number;
  overallEvents: number;
  takenEvents: number;
  takenChallenges: number;
  totalModules: number;
  overallCompletedModules: number;
  avgCompletion: number;
  avgGrade: number;
}

export interface IPreRequisiteSkill {
  modules: number;
  passedModules: number;
  completedModules?: number;
}
export interface ITrackInternship extends IPreRequisiteSkill {
  averageSkillScore: number;
  averagePillarGrade: number;
  completedChallenges: number;
  completionPercentage: number;
  totalChallenges: number;
}

export interface ITrackEntrepreneurship extends IPreRequisiteSkill {
  averageSkillScore: number;
  averagePillarGrade: number;
  events: number;
  appliedEvents: number;
  completionPercentage: number;
  completedChallenges: number;
  totalChallenges: number;
}

export interface IBaselineQuestion {
  id: string;
  createdAt: string;
  updatedAt: string;
  questionId: string;
  question: string;
}

export interface IBaselineResultItem {
  [key: string]: {
    [key: string]: {
      blurb: string;
      score: number;
    };
  };
}
export interface IBaselineResult {
  id: string;
  attempt: number;
  data: IBaselineResultItem;
  studentId?: string;
  createdAt: string;
  updatedAt?: string;
}
